import styled from "styled-components";

export const PrivacyPolicyWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f9f9f9;
  padding: 60px 20px;

  @media (max-width: 768px) {
    padding: 40px 16px;
  }
`;

export const PolicyContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  background-color: white;
  padding: 40px;
  border-radius: 0.45rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

export const PolicyTitle = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 24px;
  text-align: center;
`;

export const LastUpdated = styled.p`
  text-align: center;
  color: var(--color-text-light);
  font-size: 14px;
  margin-bottom: 40px;
  font-style: italic;
`;

export const PolicySection = styled.div`
  margin-bottom: 32px;

  h2 {
    font-size: 20px;
    font-weight: 600;
    color: var(--color-text);
    margin-bottom: 16px;
    margin-top: 24px;
  }

  h3 {
    font-size: 16px;
    font-weight: 600;
    color: var(--color-text);
    margin-bottom: 12px;
    margin-top: 16px;
  }

  p {
    font-size: 14px;
    line-height: 1.6;
    color: var(--color-text-light);
    margin-bottom: 12px;
  }

  ul,
  ol {
    margin-left: 20px;
    margin-bottom: 12px;

    li {
      font-size: 14px;
      line-height: 1.6;
      color: var(--color-text-light);
      margin-bottom: 8px;
    }
  }
`;
